// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"42417f89","593":"f73a1c97"}[chunkId] + ".chunk.css";
};